import React from 'react'

function Footer() {
  return (
    <div className='text-center h-12 flex justify-center gap-x-3'>
      <p>Design by <a href="https://shaynakit.com/landing">SHAYNAKIT</a></p>
      <p> | </p>
      <a href="https://github.com/mahli262/payna.git">Source Code</a>
    </div>
  )
}

export default Footer
